import { render, staticRenderFns } from "./adminHelp.vue?vue&type=template&id=3f29a775&scoped=true"
import script from "./adminHelp.vue?vue&type=script&lang=js"
export * from "./adminHelp.vue?vue&type=script&lang=js"
import style0 from "./adminHelp.vue?vue&type=style&index=0&id=3f29a775&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f29a775",
  null
  
)

export default component.exports